// extracted by mini-css-extract-plugin
module.exports = {"link":"LinkStyles__link___qLgH7","caret":"LinkStyles__caret___JW3Zu","settings":"LinkStyles__settings___1o-3k","linkActive":"LinkStyles__linkActive___2dcCT"};